import { getCompetitorBatchDauInfo } from '@/pages/opinion/services/competitor';
import { arrayToSimpleObj } from '@/pages/opinion/utils';
import { formatDateFunc } from '@/pages/opinion/utils/time';
import { useCallback, useEffect, useState } from 'react';

export default function useBatchDauRequest({ params }: any) {
  const [dau, setDau] = useState({});

  const requestDauData = useCallback(() => {
    getCompetitorBatchDauInfo({
      ...params,
      types: ['total', 'slice'],
      source: 'channel',
    }).then((data: any) => {
      data = data || [];
      const dauInfo: any = {};
      data.forEach(({ game, value }: any) => {
        const { total_list, list } = value;
        const timeObj = arrayToSimpleObj(list, 'value', (item) =>
          formatDateFunc(params.date_type)(item.time),
        );
        const totalObj = arrayToSimpleObj(total_list, 'value', () => 'total');

        const obj = Object.assign({}, timeObj, totalObj);

        dauInfo[game.edition_unified_id] = obj;
      });
      setDau(dauInfo);
    });
  }, [params]);

  useEffect(() => {
    if (params.edition_unified_id) {
      setDau({});
      requestDauData();
    }
  }, [params]);

  // getDauInfo: 这个方法预留，后面如果不想第一时间就请求这个接口可以传下去使用
  return {
    getDauInfo: requestDauData,
    dau,
  };
}
